<ng-container *ngTemplateOutlet="template; context: { element: this.element }"></ng-container>
